import { render, staticRenderFns } from "./ReleaseChip.vue?vue&type=template&id=6447f8dc&scoped=true"
import script from "./ReleaseChip.vue?vue&type=script&lang=js"
export * from "./ReleaseChip.vue?vue&type=script&lang=js"
import style0 from "./ReleaseChip.vue?vue&type=style&index=0&id=6447f8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6447f8dc",
  null
  
)

export default component.exports